import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueScrollTo from 'vue-scrollto';
import webp from './lib/webp';
import Vuelidate from 'vuelidate';
import Notifications from './components/notification/Notifications.vue';
import VeeValidate from 'vee-validate';
import SvgLoader from './components/common/SvgLoader.vue';
import directives from './directives';

directives.install(Vue);


Vue.use(VeeValidate);
Vue.use(Vuelidate);

Vue.config.productionTip = false;
Vue.use(VueScrollTo, {
  easing: 'ease-out',
});

Vue.component('Notifications', Notifications);
Vue.component('SvgLoader', SvgLoader);

//CSS Import
import 'sanitize.css';

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

webp.isSupported().then(function(supported) {
  if (supported) {
    store.commit('settings/webp', supported);
    document.body.classList.add('webp');
  } else {
    document.body.classList.add('no-webp');
  }
  // eslint-disable-next-line vue/script-indent
});
